var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaXlsxLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2989",
    "data-name": "Group 2989",
    transform: "translate(-336 -1336)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 40,
    height: 40,
    transform: "translate(336 1336)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987",
    transform: "translate(-7.803 -6.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(354.772 1350.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M14.581,2H6.351A2.351,2.351,0,0,0,4,4.351v18.81a2.351,2.351,0,0,0,2.351,2.351H20.459a2.351,2.351,0,0,0,2.351-2.351V10.229Z",
    transform: "translate(-4 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M13,2v8.229h8.229",
    transform: "translate(-2.419 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "X",
    transform: "translate(360.359 1370.804)",
    fill: "#0d0d0d",
    fontSize: 11,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaXlsxLargeIcon);
export default __webpack_public_path__ + "static/media/media-xlsx-large-icon.dd076d5d700fbaa9e430b970d5132898.svg";
export { ForwardRef as ReactComponent };